import Container from "../../common/Container";
import { Row, Col } from "antd";
import {
  DeskDiv,
  MobileDiv
} from "./styles";


const Footer = () => {
  return (
    <>
      <div style={{backgroundColor:"#282424",color:"#fff",paddingTop:"36px",paddingBottom:"36px"}}>
        <Container>
        <DeskDiv>
        <Row justify="space-between">
          <Col>
            <Row style={{paddingBottom:"16px"}}>
              <img src="/logoalt.png" alt="logo.png" style={{display: "block",maxWidth:"200px",maxHeight:"120px",width:"auto",height:"auto"}}/>
            </Row>
            <Row >
            <p>© 2022, Echoges NFT</p>
            </Row>
        
          </Col>
          <Col>
              <Row style={{paddingBottom:"8px",justifyContent:"center",textAlign:"center"}}>
                <p>Join our socials!</p>
              </Row>
              <Row style={{justifyContent:"center"}}>

                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://twitter.com/EchogeToken" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/twt.svg" alt="twt.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://t.me/EchDoge" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/tg.svg" alt="tg.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://discord.gg/BKAJKxhvhM" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/dsc.svg" alt="dsc.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>

              </Row>


              
              
          </Col>
        </Row>
        </DeskDiv>
        <MobileDiv>
            <Row style={{paddingBottom:"16px",justifyContent:"center"}}>
              <img src="/logoalt.png" alt="logo.png" style={{maxWidth:"171px",maxHeight:"72px",width:"auto",height:"auto"}}/>
            </Row>
            <Row style={{justifyContent:"center"}}>
            <p>© 2022, Echoges NFT</p>
            </Row>
        

              <Row style={{paddingBottom:"0px",justifyContent:"center",textAlign:"center"}}>
                <p>Join our socials!</p>
              </Row>
              <Row style={{justifyContent:"center"}}>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://twitter.com/EchogeToken" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/twt.svg" alt="twt.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://t.me/EchDoge" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/tg.svg" alt="tg.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://discord.gg/BKAJKxhvhM" target="_blank" rel="noreferrer">
                <Col>
                  
                    <img src="/img/dsc.svg" alt="dsc.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>

              </Row>


        </MobileDiv>
        
        </Container>
      </div>


    </>
  );
};

export default (Footer);
